<template>
  <div>
    <div>
      <Input v-model="multiPrice" placeholder="带票价基础上修改" style="width: 300px;display: inline-table;margin-right: 30px"
             search enter-button="预览"
             @on-search="multiChangePrice"
      >
        <template #prepend>
          <span>批量改价:</span>
        </template>
      </Input>
      <DatePicker v-model="do_time" type="datetime" placeholder="执行时间" style="width: 200px" />
      <Button type="warning" @click="multiSetPrice" :loading="doingMultiSet">确定</Button>
      <Button type="info" @click="exportStation" style="margin-left: 10px">导出站点</Button>

      <Input style="width: 200px;display: inline-table;margin-right: 10px;margin-left: 10px;" v-model="searchData.keyword" placeholder="id、名称"></Input>
      <Button type="info" @click="searchStations">搜索</Button>

    </div>
    <card :title="`总数量:${totalCount}`">
      <div class="station-table-wrap">
        <div class="station-table-inner" :style="{minWidth: stationTableMinWidth}">
          <div class="conItem header-row">
            <div class="cell bianhao">编号</div>
            <div v-if="!hidePriceColumns" class="cell auto_rule">自动调价</div>
            <div class="cell station_id">站点ID</div>
            <div class="cell gas_name">站点名称</div>
            <div class="cell update_time">更新时间</div>
            <div class="cell spread_price">价差</div>
            <div class="cell price">价格</div>
            <div class="cell station_price">站点价格</div>
            <div v-if="!hidePriceColumns" class="cell retail_prices">价格/零售价</div>
            <div v-if="!hidePriceColumns" class="cell editPrice">定时-价格/零售价</div>
            <div class="cell partner_apply">合伙人调价申请</div>
          </div>
          <div class="scroller-wrap" :style="{height: scrollerHeight, overflowY: 'auto', overflowX: 'hidden'}">
            <div v-for="(item, index) in tableData" :key="item.station_id" class="conItem">
          <div class="cell bianhao">{{(currentPage - 1) * pageSize + index + 1}}</div>
            <div v-if="!hidePriceColumns" class="cell auto_rule">
              <i-switch :value="item.is_rule===1" @on-change="val => toggleCompanyStationRule(item, val)" />
            </div>
            <div class="cell station_id">
              <span>{{item.station_id}}</span>
              <Tag color="orange">{{item.platform}}</Tag>
            </div>
            <div class="cell gas_name">
              <span>{{item.gas_name}}</span>
              <Tag color="orange">{{item.is_bill===1 ? 'A型' : 'B型'}}</Tag>
            </div>
            <div class="cell update_time">{{item.update_time}}</div>
            <div class="cell spread_price">{{item.spread_price}}</div>
            <div class="cell price cell-stack">
              <span>A型 : {{item.price2}}</span>
              <span>B型 : {{item.no_bill_price}}</span>
              <span>车队价格 : {{item.has_company_price === 1 ? item.company_price : '未设置'}}</span>
            </div>
            <div class="cell station_price cell-stack">
              <span>油机价 : {{item.station_price}}</span>
              <span>挂牌价 : {{item.ndrc_price}}</span>
            </div>
            <div v-if="!hidePriceColumns" class="cell retail_prices cell-stack retail_value">
              <span class="price_pair">{{item.company_price}} / {{item.retail_prices}}</span>
            </div>
            <div v-if="!hidePriceColumns" class="cell editPrice cell-stack">
              <span class="fixed_time">{{item.fixed_time || '立即生效'}}</span>
              <div class="edit_inputs">
                <Input class="editPriceInput" v-model="item.new_company_price" size="small"/>
                <span class="edit_split">/</span>
                <Input class="editPriceInput" v-model="item.new_retail_prices" size="small"/>
              </div>
              <Button type="primary" @click="editCompanyStationPrice(item)" size="small">立即修改</Button>
            </div>
            <div class="cell partner_apply cell-stack">
              <Tag :color="getApplyStatusColor(item.partner_apply_status)">{{ item.partner_apply_status_text || '无申请' }}</Tag>
              <span v-if="item.partner_apply_status===1" class="apply_price_change">{{item.partner_apply_old_price}} -> {{item.partner_apply_new_price}}</span>
              <span v-if="item.partner_apply_time" class="apply_meta">{{item.partner_apply_time}}</span>
              <span v-if="item.partner_apply_remark" class="apply_meta">备注：{{item.partner_apply_remark}}</span>
              <span v-if="item.partner_apply_status===3 && item.partner_apply_reject_reason" class="apply_meta reject_reason">拒绝原因：{{item.partner_apply_reject_reason}}</span>
              <div v-if="item.partner_apply_status===1" class="apply_actions">
                <Button type="success" size="small" @click="agreePartnerApply(item)">同意</Button>
                <Button type="error" size="small" @click="showRejectApplyModal(item)">拒绝</Button>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
        <div style="margin-top: 12px; text-align: right;">
          <Page
            show-sizer
            show-elevator
            show-total
            transfer
            :total="totalCount"
            :current="currentPage"
            :page-size="pageSize"
            :page-size-opts="pageSizeOptions"
            @on-change="handlePageChange"
            @on-page-size-change="handlePageSizeChange"
          />
        </div>
      
    </card>
    <!-- 多种油品 Modal -->
    <Modal v-model="multiOilModal.isShow" title="多种油品设置" width="760" :closable="true">
      <div v-if="multiOilModal.loading">加载中...</div>
      <div v-else>
        <div style="max-height:400px;overflow:auto;">
          <div v-for="(p, idx) in multiOilModal.list" :key="idx" style="display:flex;align-items:center;padding:6px;border-bottom:1px solid #f0f0f0">
            <div style="width:180px">{{p.oil_no_name}}</div>
            <div style="width:80px">
              <Tag :color="p.enabled ? 'success' : 'gray'">{{p.enabled ? '已启用' : '已禁用'}}</Tag>
            </div>
            <div style="width:120px">
              <Input size="small" :disabled="!p.enabled" v-model="p.company_price" placeholder="车队价" />
            </div>
            <div style="width:120px;margin-left:8px">
              <Input size="small" :disabled="!p.enabled" v-model="p.retail_prices" placeholder="零售价" />
            </div>
            <div style="flex:1;text-align:right">
              <Button type="primary" size="small" :disabled="!p.enabled" @click="saveSingleCompanyProduct(p)">保存</Button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button @click="multiOilModal.isShow=false">关闭</Button>
        <Button type="primary" @click="saveAllCompanyProducts" :loading="multiOilModal.saving">全部保存</Button>
      </div>
    </Modal>
    <Modal v-model="rejectApplyModal.isShow" title="拒绝调价申请" :loading="rejectApplyModal.loading" @on-ok="rejectPartnerApply">
      <Form :label-width="80">
        <FormItem label="拒绝原因">
          <Input v-model="rejectApplyModal.reason" type="textarea" :rows="3" maxlength="120" placeholder="请输入拒绝原因"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!--<pageTable
                ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :showSearchForm="false"
                :tableData="tableData"
    >
    </pageTable>-->
  </div>
</template>

<script>
  import XLSX from 'xlsx'
  import { RecycleScroller } from 'vue-virtual-scroller'
  export default {
    name: "companyStation",
    // pageTable not used in this view (list rendering is custom)
    props:{
      companyId:{
        type:Number,
        default: 0
      },
      partnerApplyStatus:{
        type:[Number,String],
        default: ''
      },
      hidePriceColumns:{
        type:Boolean,
        default:false
      }
    },
    data(){
      return {
        searchData:{
          company_id:this.companyId,
          keyword:'',
          partner_apply_status:this.partnerApplyStatus,
        },
        multiPrice:'',
        do_time:'',
        doingMultiSet:false,
        currentPage: 1,
        pageSize: 50,
        totalCount: 0,
        pageSizeOptions: [50, 100, 200, 500],
        tableColumn: [
          {title: '编号',type: 'index',align: "center",width:80},
          {title: '站点ID',key: 'station_id',align: "center"},
          {title: '站点名称',key: 'gas_namegas_name',align: "center",render:(h,params)=>{
              return h('div',[
                h('p',params.row.gas_name),
                h('Tag',{props:{color:'orange'}},params.row.is_bill===1 ? 'A型' : 'B型'),
              ])
            }},
          {title: '更新时间',key: 'update_time',width:180,align: "center"},
          {title: '价差',key: 'spread_price',align: "center"},
          {title: '价格',key: 'price',align: "left",width:200,render:(h,params)=>{
            return h('div',[
              h('p',`A型 : ${params.row.price2}`),
              h('p',`B型 : ${params.row.no_bill_price}`),
              h('p',`车队价格 : ${params.row.has_company_price === 1 ? params.row.company_price : '未设置'}`),
            ])
            }},
          {title: '站点价格',key: 'price',align: "left",width:160,render:(h,params)=>{
              return h('div',[
                h('p',`油机价 : ${params.row.station_price}`),
                h('p',`挂牌价 : ${params.row.ndrc_price}`),
              ])
            }},
          // {title: '对内价格',key: 'price2',align: "center",width:100},
          // {title: '不带票价格',key: 'no_bill_price',align: "center",width:100},
          /*{title: '车队价格',key: 'company_price',align: "center",render:(h,params)=>{
            return h('Tag',{
              props:{color:params.row.has_company_price === 1?'default':'warning'}
            },params.row.has_company_price === 1 ? params.row.company_price : '未设置')
            }},*/
          {title: '价格/零售价',align: "center",width:160,render:(h,params)=>{
            return h('span',`${params.row.company_price} / ${params.row.retail_prices}`)
            }},
          {title: '定时-价格/零售价',align: "center",width:240,render:(h,params)=>{
              return h('div',[
                h('Input',{
                  style:{width:'60px',marginRight:'5px'},
                  props:{value:params.row.new_company_price,size:'small'},
                  on:{
                    input:(val)=>{
                      this.$set(params.row,'new_company_price',val)
                    }
                  }
                }),
                h('Input',{
                  style:{width:'60px',marginRight:'5px'},
                  props:{value:params.row.new_retail_prices,size:'small',placeholder:'建议零售价'},
                  on:{
                    input:(val)=>{
                      this.$set(params.row,'new_retail_prices',val)
                    }
                  }
                }),
                h('Button',{
                  props: {type: 'primary', size: 'small'},
                  on: {click: () => {this.editCompanyStationPrice(params.row)}}
                },'修改')
              ])
            }},
        ],
        tableData:[],
        // 虚拟滚动配置
        itemSize: 56, // 每行高度
        scrollerHeight: '70vh', // 滚动区域高度
        tableTitle:'总数量:',
        loading:false,
        // 多种油品弹窗数据
        multiOilModal: {
          isShow: false,
          loading: false,
          saving: false,
          station_id: 0,
          list: [],
        },
        rejectApplyModal: {
          isShow: false,
          loading: false,
          station_id: 0,
          reason: '',
        },
      }
    },
    components: { RecycleScroller },
    computed:{
      stationTableMinWidth(){
        return this.hidePriceColumns ? '1140px' : '1540px'
      }
    },
    mounted(){
      this.getTableData()
    },
    methods:{
      // 打开多种油品弹窗
      async showMultiOilModal(item){
        this.multiOilModal.isShow = true;
        this.multiOilModal.loading = true;
        this.multiOilModal.station_id = item.station_id;
        this.multiOilModal.list = [];
        try{
          await this.loadMultiOilProducts();
        }catch(e){
          this.multiOilModal.loading = false;
          this.multiOilModal.list = [];
        }
      },

      // 加载站点油品，并准备公司价格字段（仅用于编辑价格，不修改启用状态）
      async loadMultiOilProducts(){
        let res = await this.$commonFun.postProxy('admin/company/getCompanyStationProducts',{station_id: this.multiOilModal.station_id , company_id: this.companyId});
        this.multiOilModal.loading = false;
        this.$commonFun.dealApiResult(res, ()=>{
          let arr = res.data || [];
          // 以返回的产品为准，若需要可扩展为完整 oilOptions 列表
          this.multiOilModal.list = (arr.map(item => {
            return {
              id: item.gun_id || item.id || null,
              oil_no: item.oil_no !== undefined ? item.oil_no : '',
              oil_no_name: item.oil_no_name || item.oil_name || String(item.oil_no || ''),
              enabled: item.status === 1 || item.enabled === 1 || true,
              company_price: item.company_price !== undefined ? item.company_price : (item.company_price || ''),
              retail_prices: item.retail_prices !== undefined ? item.retail_prices : (item.retail_prices || ''),
            }
          }))
        })
      },

      // 保存单条油品的车队价格（只保存价格，不修改启用）
      async saveSingleCompanyProduct(p){
        let payload = {
          company_id: this.companyId,
          station_id: this.multiOilModal.station_id,
          oil_no: p.oil_no,
          company_price: p.company_price === '' ? '' : Number(p.company_price),
          retail_prices: p.retail_prices === '' ? '' : Number(p.retail_prices),
        }
        let res = await this.$commonFun.postProxy('admin/company/editCompanyStationProduct', payload);
        this.$commonFun.dealApiResult(res, ()=>{
          this.$Message.success(res.msg || '保存成功');
          // 可选择刷新列表
        })
      },

      // 批量保存当前弹窗中所有可编辑的油品价格
      async saveAllCompanyProducts(){
        this.multiOilModal.saving = true;
        let prices = this.multiOilModal.list.map(p=>({
          oil_no: p.oil_no,
          company_price: p.company_price === '' ? '' : Number(p.company_price),
          retail_prices: p.retail_prices === '' ? '' : Number(p.retail_prices),
        }))
        let res = await this.$commonFun.postProxy('admin/company/multiEditCompanyStationProduct', {company_id: this.companyId, station_id: this.multiOilModal.station_id, prices});
        this.$commonFun.dealApiResult(res, ()=>{
          this.$Message.success(res.msg || '保存成功');
          this.multiOilModal.isShow = false;
          this.getTableData();
        })
        this.multiOilModal.saving = false;
      },
      async getTableData(){
        let params = {
          ...this.searchData,
          page: this.currentPage,
          pagesize: this.pageSize,
        }
        let res = await this.$commonFun.postProxy('admin/company/getCompanyStation', params)
        this.$commonFun.dealApiResult(res,()=>{
          this.tableData = res.data || []
          this.totalCount = Number(res.count || 0)
        })
        return false;
      },
      getApplyStatusColor(status){
        const map = {0:'default',1:'warning',2:'success',3:'error'}
        return map[status] || 'default'
      },
      async agreePartnerApply(info){
        let params = {
          company_id: this.companyId,
          station_id: info.station_id,
          action: 'agree'
        }
        let res = await this.$commonFun.postProxy('admin/company/auditCompanyStationPriceAdjust', params)
        this.$commonFun.dealApiResult(res, ()=>{
          this.$commonFun.successTip(res.msg || '操作成功', ()=>{
            this.getTableData()
          })
        })
      },
      showRejectApplyModal(info){
        this.rejectApplyModal.isShow = true
        this.rejectApplyModal.loading = false
        this.rejectApplyModal.station_id = info.station_id
        this.rejectApplyModal.reason = ''
      },
      async rejectPartnerApply(){
        if (!this.rejectApplyModal.station_id){
          return this.$commonFun.errorTip('参数错误')
        }
        this.rejectApplyModal.loading = true
        let params = {
          company_id: this.companyId,
          station_id: this.rejectApplyModal.station_id,
          action: 'reject',
          reject_reason: this.rejectApplyModal.reason
        }
        let res = await this.$commonFun.postProxy('admin/company/auditCompanyStationPriceAdjust', params)
        this.rejectApplyModal.loading = false
        this.$commonFun.dealApiResult(res, ()=>{
          this.$commonFun.successTip(res.msg || '操作成功', ()=>{
            this.rejectApplyModal.isShow = false
            this.rejectApplyModal.station_id = 0
            this.rejectApplyModal.reason = ''
            this.getTableData()
          })
        })
      },
      searchStations(){
        this.currentPage = 1
        this.getTableData()
      },
      handlePageChange(page){
        this.currentPage = page
        this.getTableData()
      },
      handlePageSizeChange(size){
        this.pageSize = size
        this.currentPage = 1
        this.getTableData()
      },
      async editCompanyStationPrice(info){
        let params = {
          company_id: this.companyId,
          station_id:info.station_id,
          price:info.new_company_price,
          retail_prices:info.new_retail_prices
        }
        let res = await this.$commonFun.postProxy('admin/company/editCompanyStationPrice',params);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.getTableData()
            // this.$refs.table.resetSearchForm()
          })
        })
      },
      multiChangePrice(value){
        // this.$refs.table.tableData.forEach(item=>{
        this.tableData.forEach(item=>{
          if (item.company_price && item.company_price>0){
            item.new_company_price =value ? (parseFloat(item.price2)+parseFloat(value)).toFixed(2) : item.company_price;
            item.new_retail_prices =value ? parseFloat(parseFloat(item.retail_prices) - parseFloat(item.company_price) + parseFloat(item.new_company_price)).toFixed(2) : item.retail_prices;
          }else{
            item.new_company_price = 0;
            item.new_retail_prices = 0;
          }
        })
      },
      async multiSetPrice(){
        this.doingMultiSet = true
        // let res = await this.$commonFun.postProxy('admin/company/multiEditCompanyStationPrice',{company_id: this.companyId,price:this.multiPrice,do_time:this.do_time});
        // let data = this.$refs.table.tableData.map(item=>{
        let data = this.tableData.map(item=>{
          return {station_id:item.station_id,new_company_price:item.new_company_price,new_retail_prices:item.new_retail_prices}
        })
        let res = await this.$commonFun.postProxy('admin/company/multiEditCompanyStationPrice',{company_id: this.companyId,prices:data,do_time:this.do_time});
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg)
          this.getTableData()
          // this.$refs.table.resetSearchForm()
        })
        this.doingMultiSet = false
      },
      async exportStation(){
        let res = await this.$commonFun.postProxy('admin/company/exportCompanyStation',this.searchData)
        this.$commonFun.dealApiResult(res,()=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`${res.data.filename}.xlsx`)
        })
      },
      async toggleCompanyStationRule(item, val){ // 切换自动调价规则 开启
        const old = item.is_rule;
        // optimistic update
        this.$set(item, 'is_rule', val ? 1 : 0);
        try{
          let res = await this.$commonFun.postProxy('admin/company/editCompanyStationRule',{company_id: this.companyId, station_id: item.station_id, is_rule: val?1:0});
          this.$commonFun.dealApiResult(res, ()=>{
            this.$Message.success(res.msg || '设置成功')
          }, ()=>{
            // revert on failure
            this.$set(item, 'is_rule', old);
            // 设置为开启状态时，重新获取数据以应用自动调价规则
            if (val == 1) {this.getTableData()}
          })
        }catch(e){
          this.$set(item, 'is_rule', old);
        }
      },
      set_new_company_price(row,ttt){
        console.log('row0--0--',row)
        console.log('ttt---',ttt)
      }

    }
  }
</script>

<style scoped lang="less">
  .station-table-wrap{
    overflow-x: auto;
    overflow-y: hidden;
  }
  .station-table-inner{
    min-width: 1540px;
  }
  .conItem{
    display: flex;
    border: 1px solid #e8eaec;
    padding: 8px 10px;
    align-items: center;
    border-bottom: none;
    >.cell{
      margin-right: 10px;
      text-align: center;
      flex-shrink: 0;
      min-width: 0;
    }
    .bianhao{
      width: 80px;
    }
    .station_id{
      width: 100px;
      >span{
        display: block;
      }
    }
    .gas_name{
      width: 120px;
      >span{
        display: block;
      }
    }
    .update_time{
      width: 140px;
    }
    .price{
       width: 140px;
       >span{
         display: block;
       }
     }
    .station_price{
      width: 160px;
      >span{
        display: block;
      }
    }
    .spread_price{
      width: 100px;
    }
    .retail_prices{
      width: 140px;
    }
    .editPrice{
      width: 170px;
      .editPriceInput{
        width:60px;
      }
      .fixed_time{
        color: #808695;
        font-size: 12px;
        line-height: 18px;
      }
      .edit_inputs{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 6px 0;
      }
      .edit_split{
        margin: 0 6px;
      }
    }
    .partner_apply{
      width: 180px;
      .apply_price_change{
        font-weight: 500;
        color: #17233d;
      }
      .apply_meta{
        color: #808695;
        line-height: 18px;
        word-break: break-all;
      }
      .reject_reason{
        color: #ed4014;
      }
      .apply_actions{
        margin-top: 4px;
        display: flex;
        align-items: left;
        justify-content: left;
        gap: 6px;
      }
    }
    .auto_rule{
      width:100px;
      text-align:center;
    }
  }
  .header-row{
    background: #f8f8f9;
    font-weight: 600;
    color: #17233d;
  }
  .conItem + .conItem{
    border-top: none;
  }
  .cell-stack{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 4px;
  }
  .retail_value{
    .price_pair{
      font-weight: 500;
      line-height: 20px;
      word-break: break-all;
    }
  }
</style>